const cities = [
  { name: "Lakeland", zips: "33801–33815" },
  { name: "Winter Haven", zips: "33880–33884" },
  { name: "Bartow", zips: "33830" },
  { name: "Auburndale", zips: "33823" },
  { name: "Plant City", zips: "33563–33567" },
  { name: "Kissimmee", zips: "34741–34747" },
  { name: "Tampa", zips: "33601–33626" },
  { name: "Orlando", zips: "32801–32839" },
  { name: "Lake Wales", zips: "33853–33859" },
  { name: "Haines City", zips: "33844–33845" },
];

const benefits = [
  { icon: "ri-time-line", title: "Tampa Office — 35 Min Away", desc: "The closest Fast Passport Center office is at 400 N Ashley Dr #1700, Tampa — just 35 minutes west on I-4. Drop off or use courier pickup." },
  { icon: "ri-shield-check-line", title: "Registered Courier", desc: "We are a U.S. Department of State registered passport courier — Lakeland residents get the same agency access as DC residents." },
  { icon: "ri-customer-service-2-line", title: "Live Support", desc: "Real agents available by phone Mon–Fri. No bots, no ticket queues for your Lakeland application." },
  { icon: "ri-mail-send-line", title: "Ship from Anywhere", desc: "Ship from Lakeland Post Office, FedEx on South Florida Ave, or UPS. We provide tracking and confirm receipt of your documents." },
];

const internalLinks = [
  { name: "Tampa Office", route: "/tampa" },
  { name: "Orlando", route: "/orlando" },
  { name: "Miami", route: "/miami" },
  { name: "Florida State Hub", route: "/florida" },
  { name: "Kissimmee", route: "/kissimmee" },
];

export default function LocalAreaSection() {
  return (
    <section id="service-area" className="bg-white pt-6 md:pt-8 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Lakeland &amp; Polk County
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Fast Passport Center serves the entire Lakeland metro area — Polk County, the I-4 corridor, and Central Florida. Our closest physical office is in downtown Tampa, just 35 minutes away via I-4. No local agency visit required — ship documents from anywhere in the Lakeland area.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Tampa (Closest Office to Lakeland)</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving all of Polk County &amp; Central Florida</p>
                </div>
              </div>

              <div className="bg-white/10 rounded-md p-4 mb-4">
                <p className="text-[#F6C344] text-xs font-bold uppercase tracking-wider mb-1">
                  <i className="ri-building-line mr-1.5"></i>
                  Closest Physical Office — By Appointment Only
                </p>
                <p className="text-white text-sm font-medium leading-relaxed">400 N Ashley Dr #1700, Tampa, FL 33602</p>
                <p className="text-white/60 text-xs mt-1">Visit by appointment, or choose courier pickup and drop-off for added convenience — we come to your Lakeland home or office.</p>
              </div>

              <div className="rounded-md overflow-hidden mb-4 h-[200px]">
                <iframe
                  src="https://maps.google.com/maps?q=400+N+Ashley+Dr+Tampa+FL+33602&z=13&output=embed"
                  title="Fast Passport Center Tampa Office — closest office to Lakeland FL"
                  className="w-full h-full"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Miami Passport Agency — 280 miles southeast via I-4 and I-75
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier Pick Up Available — we come to your home or office in Lakeland &amp; Polk County</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  Lakeland is a growing Central Florida city at the heart of Polk County. The Fast Passport Center Tampa office at 400 N Ashley Dr is your closest physical location — just 35 minutes west on I-4. Drop off documents in person by appointment, or let our courier service handle everything from your doorstep. As a registered U.S. Department of State courier, we have guaranteed submission availability at the Miami Passport Agency — no personal travel needed.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md">
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                We serve all Lakeland zip codes and surrounding Polk County communities. Overnight delivery accepted from anywhere in Central Florida.
              </p>

              {/* Closest FPC Office Callout */}
              <div className="mt-4 p-4 bg-[#F6C344]/10 rounded-lg border border-[#F6C344]/30">
                <div className="flex items-start gap-2.5">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0 mt-0.5">
                    <i className="ri-building-line text-[#1A365D] text-sm"></i>
                  </div>
                  <div>
                    <p className="font-bold text-[#1A365D] text-sm mb-1">Closest Fast Passport Center</p>
                    <p className="text-[#1A365D] text-xs leading-relaxed">
                      <strong>400 N Ashley Dr #1700, Tampa, FL 33602</strong> — just 35 minutes west on I-4 from downtown Lakeland. <strong>By appointment only</strong> for in-person document drop-off. <strong>Courier pickup available</strong> — we&apos;ll come to you anywhere in Lakeland or Polk County.
                    </p>
                    <a
                      href="/cities/tampa"
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-semibold mt-2 transition-colors"
                    >
                      View Tampa Office Details <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {internalLinks.map((link) => (
                    <a
                      key={link.route}
                      href={link.route}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a key={i} href="https://fastpassportcenter.com" className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}